import  { useState } from 'react';
import { Form, Input, Button, Card, Typography, Layout, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import useAuthApis from '../apis/useAuthApis';

const { Title } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { loginApi } = useAuthApis();


  const onFinish = async (values) => {
    setLoading(true);
    const res = await loginApi(values);
    if (res.error) {
      message.error(res.message || 'Invalid email or password');
      setLoading(false);

    } else {
      message.success('Login successful.');
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '400px', 
        margin: '0 auto', 
        marginTop: '10vh' 
      }}>
        <Card style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/478px-Seal_of_Uttar_Pradesh.svg.png"
              alt="UP Logo"
              style={{
                height: '80px',
                marginBottom: '20px'
              }}
            />
            <Title level={2} style={{ margin: 0 }}>
              UP Municipal Admin
            </Title>
            <Title level={4} style={{ margin: 0, fontWeight: 'normal', color: 'rgba(0, 0, 0, 0.45)' }}>
              Login to your account
            </Title>
          </div>

          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' }
              ]}
            >
              <Input 
                prefix={<UserOutlined />} 
                placeholder="Email" 
                size="large" maxLength={50}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'Please input your password!' },
                { min: 5, message: 'Password must be at least 5 characters!' }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                size="large" maxLength={50}
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                block 
                size="large"
                loading={loading}
              >
                Login
              </Button>
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <Link to="/forgot-password" style={{ marginRight: '10px' }}>
                Forgot Password?
              </Link>
             
            </div>
          </Form>
        </Card>
      </div>
    </Layout>
  );
};

export default Login; 